import React from 'react';

export function takingABreak() {
  return (
    <div>
      <div className='para'>I know it sounds absurd, me saying that I’m taking a break from publishing posts, after only doing 3 of them on a half finished website.</div>
      <div className='para'>
        Writing has always been a great source of joy for me, but for the most part, because the audience included none but myself, a wicked feedback loop developed, some sort of augean stables of
        ideas and memories. Without needless romanticization of the golden age of the internet, let me say, that midway between the trash that is social media, and the limitless expressive freedom of
        completely anonymized internet whiteboards, personal websites without analytics embedded are safe spaces I enjoy. You revise and censure your posts, for an audience you cannot see, an audience
        whose general character is understood, yet are unknown.
      </div>
      <div className='para'>
        All this, while exciting, has become an activity that I associate with a chaotic state of mind and I need some time off to recalibrate. A Personal website is not a side of you that you
        advertise, yet it is there to find, for people who look. So I thank you dear reader unknown for your friendship.
      </div>
    </div>
  );
}
